import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(
    private http: HttpClient
  ) { }

  login(username: string, password: string): Observable<any> {
    const req = {
      username,
      password,
      rememberMe: false
    };

    return this.http.post(environment.api_url + 'authenticate', req, { observe: 'response' });
  }

  resetPassword(username: String) {
    return this.http.post(environment.api_url + 'reset-password', username, { responseType: 'text' });
  }

}